const describeInventoryItemByUID = (inventory, itemId) => {
  for (let bag_index = 0; bag_index < inventory.bags.length; ++bag_index) {
    const bag = inventory.bags[bag_index]?.value;
    if (!bag) {
      continue;
    }

    for (let item_index = 0; item_index < bag.items.length; ++item_index) {
      const item = bag.items[item_index]?.value;
      if (item?.uid === itemId) {
        return {
          item,
          bag_index,
          item_index,
        };
      }
    }
  }
};
module.exports = describeInventoryItemByUID;
